import Swiper from "swiper/swiper-bundle";

function checkVideo(currentSlide) {
    let video = $(currentSlide).find('video');
    if (!!video.length) {
        video[0].pause();
        video[0].currentTime = 0;
        video[0].play();
    }
}

function sliderNavigation(prevBtn, nextBtn, carousel) {

    prevBtn.addEventListener('click', () => {
        if (carousel.realIndex - 1 < 0) {
            carousel.slideTo(carousel.slides.length);
        } else {
            carousel.slideTo(carousel.realIndex - 1);
        }
    });

    nextBtn.addEventListener('click', () => {
        if (carousel.realIndex + 1 == carousel.slides.length) {
            carousel.slideTo(0);
        } else {
            carousel.slideTo(carousel.realIndex + 1);
        }
    });
}

// Hero top slider
let heroSliderSlidesLength = $('.hero__slider .swiper-slide').length;
let topSliderOptions = {};

if (heroSliderSlidesLength > 1) {
    topSliderOptions = {
        loop: true,
    }
} else {
    topSliderOptions = {
        loop: false
    }
}

const topSlider = new Swiper('.hero__slider', {
    autoplay: {
        delay: 8000,
    },
    speed: 1000,
    simulateTouch: false,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
    },
    pagination: {
        clickable: true,
        el: '.swiper-pagination'
    },
    ...topSliderOptions,
    on: {
        init: function () {
            let index = this.realIndex;
            checkVideo(this.slides[index]);
        },
        slideChange: function () {
            let index = this.activeIndex;
            checkVideo(this.slides[index]);
        }
    },
});



// Gallery sliders
const gallerySliders = document.querySelectorAll('.slider-gallery-init');
gallerySliders.forEach((gallerySlider) => {
    let pagItems = gallerySlider.parentNode.querySelector('.slider-pagination__counter');
    let pagItemPrev = gallerySlider.parentNode.parentNode.parentNode.querySelector('.slider-button--prev');
    let pagItemNext = gallerySlider.parentNode.parentNode.parentNode.querySelector('.slider-button--next');

    const slide = new Swiper(gallerySlider, {
        autoplay: {
            delay: 3000
        },
        loop: true,
        speed: 1000,
        spaceBetween: 30,
        slidesPerView: 1,
        simulateTouch: false,
        pagination: {
            el: pagItems,
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                return `
                <span class="slider-pagination__counter-current">${(current < 10) ? '0' + current : current}</span>
                <span class="slider-pagination__counter-separator">/</span>
                <span class="slider-pagination__counter-total">${(total < 10) ? '0' + total : total}</span>
                `
            }
        },
        navigation: {
            prevEl: pagItemPrev,
            nextEl: pagItemNext,
            disabledClass: 'slider-button--disabled'
        },
    });
});

const galleryOffsetSlider = document.querySelectorAll('.slider-gallery-offset-init');
galleryOffsetSlider.forEach((gallerySlider) => {
    let pagItemPrev = gallerySlider.parentNode.parentNode.querySelector('.slider-button--prev');
    let pagItemNext = gallerySlider.parentNode.parentNode.querySelector('.slider-button--next');

    const slide = new Swiper(gallerySlider, {
        autoplay: {
            delay: 3000
        },
        loop: true,
        speed: 1000,
        spaceBetween: 30,
        slidesPerView: 1,
        simulateTouch: false,
        navigation: {
            prevEl: pagItemPrev,
            nextEl: pagItemNext,
            disabledClass: 'slider-button--disabled'
        },
    });
});


// Features slider
const featuresSlider = document.querySelectorAll('.features-block-slider-init');
featuresSlider.forEach((slider) => {
    let pagItemPrev = slider.parentNode.parentNode.querySelector('.slider-button--prev');
    let pagItemNext = slider.parentNode.parentNode.querySelector('.slider-button--next');

    const slide = new Swiper(slider, {
        autoplay: {
            delay: 3000
        },
        speed: 1000,
        spaceBetween: 30,
        slidesPerView: 1,
        simulateTouch: false,
        navigation: {
            prevEl: pagItemPrev,
            nextEl: pagItemNext,
            disabledClass: 'slider-button--disabled'
        },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            },
        }
    });
});